import React, { useRef } from 'react';
import { IItemCreationSubsectionInputProps, ItemCreationSubsection } from '~/Components';
import { useStyles } from '../HelperMerchant/Merchant.style';
import { IMerchant, FormGroups } from '~/Models/DTO/Merchant.models';
import { useFieldsByGroup } from '../HelperMerchant/useFieldsByGroup';
export const MerchantFields = ({
  fields,
  groups,
  setConsent,
  billable,
  setBillable,
  customField,
  setCustomField,
  consent,
  country,
  create,
}: any) => {
  const { classes } = useStyles();
  const containerRef = useRef(null);

  const { getFieldsById, getGroupLabel } = useFieldsByGroup({
    fields,
    groups,
    values: {
      billable,
      consent,
      country,
    } as IMerchant,
    setConsent,
    setBillable,
    customField,
    setCustomField,
    containerRef,
    create,
  });
  return (
    <div data-testid="MerchantFields" ref={containerRef}>
      {groups.map(({ value, label }: FormGroups) => {
        const items: IItemCreationSubsectionInputProps<Partial<IMerchant>>[] = [];
        items.push(...getFieldsById(value));
        if (!items.length) return <></>;
        return (
          <div className={classes.sections} key={label}>
            {getGroupLabel(value)}
            <div className={classes.sectionContent}>
              <ItemCreationSubsection items={items} noBorder showErrorLabel isEdit={!create} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
